import { h } from 'vue'
import AtomButton from '~/components/atoms/button/button.vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentHeading from '~ui/components/heading/heading.vue'
import UiComponentImage from '~ui/components/image/image.vue'
import UiComponentParagraph from '~ui/components/paragraph/paragraph.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const Functional = (props) => {
  return h(UiComponentContainer, { class: 'use-cases' }, () => [
    (props.record.title || props.record.text)
    && h(UiComponentWrapper, { class: 'hero' }, () => [
      props.record.title
      && h(UiComponentHeading, { as: 'paragraph', level: 2 }, () => [
        props.record.title,
      ]),
      props.record.text
      && h(UiComponentParagraph, { class: 'description' }, () => [props.record.text]),
    ]),
    h(UiComponentWrapper, { class: 'mobile' }, () => [
      ...props.record.useCases.map((useCase, index) => {
        return h(
          UiComponentWrapper,
          {
            class: `use-case ${useCase.themeColor.color}`,
            key: useCase.id,
          },
          () => [
            h(UiComponentWrapper, { class: 'background' }, () => [
              useCase.icon
              && h(UiComponentImage, {
                alt: useCase.icon.alt,
                class: 'icon',
                expectedSize: 24,
                height: useCase.icon.height,
                source: useCase.icon.url,
                width: useCase.icon.width,
              }),
            ]),
            h(UiComponentHeading, { as: 'paragraph', level: 3 }, () => [
              useCase.shortName,
            ]),
            h(UiComponentParagraph, {}, () => [useCase.description]),
            index === props.record.useCases.length - 1
            && h(
              AtomButton,
              {
                action: props.page.ctaCustom
                  ? undefined
                  : props.mainButton.action,
                label: props.page.ctaCustom
                  ? undefined
                  : 'Use cases section CTA',
                size: 'l',
                to: props.page.ctaCustom?.slug || props.mainButton.to,
                onClick: () => {
                  if (!props.page.ctaCustom) {
                    props.mainButton.onClick()
                  }
                },
              },
              () => [props.page.ctaCustom?.slot || props.mainButton.slot],
            ),
          ],
        )
      }),
    ]),
    h(UiComponentWrapper, { class: 'desktop' }, () => [
      h(UiComponentWrapper, { class: 'list' }, () => [
        ...props.record.useCases.map((useCase, index) => {
          return h(
            UiComponentWrapper,
            {
              key: useCase.id,
              class: [
                'item',
                { active: index === props.useCasesActiveIndex },
              ],
              onClick: () => {
                props.useCasesGlide?.go(`=${index}`)
              },
            },
            () => [h(UiComponentParagraph, {}, () => [useCase.shortName])],
          )
        }),
      ]),
      h(UiComponentWrapper, { class: 'slider glide' }, () => [
        h(
          UiComponentWrapper,
          {
            class: 'inner glide__track',
          },
          () => [
            h(
              UiComponentWrapper,
              {
                class: 'flex glide__slides',
              },
              () => [
                ...props.record.useCases.map((useCase) => {
                  return h(
                    UiComponentWrapper,
                    {
                      class: `glide__slide swiper-slide use-case ${useCase.themeColor.color}`,
                      key: `desktop-slide-${useCase.id}`,
                    },
                    () => [
                      h(UiComponentWrapper, { class: 'content' }, () => [
                        h(UiComponentWrapper, { class: 'background' }, () => [
                          useCase.icon
                          && h(UiComponentImage, {
                            alt: useCase.icon.alt,
                            class: 'icon',
                            expectedSize: 24,
                            height: useCase.icon.height,
                            source: useCase.icon.url,
                            width: useCase.icon.width,
                          }),
                        ]),
                        h(
                          UiComponentHeading,
                          { as: 'paragraph', level: 3 },
                          () => [useCase.shortName],
                        ),
                        h(UiComponentParagraph, {}, () => [useCase.description]),
                        h(
                          AtomButton,
                          {
                            action: props.page.ctaCustom
                              ? undefined
                              : props.mainButton.action,
                            label: props.page.ctaCustom
                              ? undefined
                              : 'Use cases section CTA',
                            size: 'l',
                            to:
                              props.page.ctaCustom?.slug
                              || props.mainButton.to,
                            onClick: () => {
                              if (!props.page.ctaCustom) {
                                props.mainButton.onClick()
                              }
                            },
                          },
                          () => [
                            props.page.ctaCustom?.slot
                            || props.mainButton.slot,
                          ],
                        ),
                      ]),
                      useCase.image
                      && h(UiComponentImage, {
                        alt: useCase.image.alt,
                        class: 'picture',
                        expectedSize: 572,
                        height: useCase.image.height,
                        source: useCase.image.url,
                        width: useCase.image.width,
                      }),
                    ],
                  )
                }),
              ],
            ),
          ],
        ),
      ]),
    ]),
  ])
}

Functional.props = {
  mainButton: {
    required: true,
    type: Object,
  },
  page: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
  track: {
    required: true,
    type: Function,
  },
  useCasesActiveIndex: {
    required: true,
    type: Number,
  },
  useCasesGlide: {
    required: true,
    type: Object,
  },
}

export default Functional
